import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Content } from "./content";

import { MainHelp } from "./components/main";
import { ProfileHelp } from "./components/profile";
import { AppsHelp } from "./components/apps";
import { BooksHelp } from "./components/books";
import { PlatformHelp } from "./components/platform";
import { DownloadHelp } from "./components/download";

/**
 * Componente que muestra las diferentes secciones de ayuda. su principal función es mostrar el contenido correspondiente a la url
 * @param {object} helpTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} HelpContent
 */
export const HelpContent = ({ helpTexts }) => {
    const urlAyuda = {
        principal: "/ayuda",
        libros: "/ayuda/libros",
        plataforma: "/ayuda/plataforma",
        descarga: "/ayuda/descarga",
        apps: "/ayuda/apps",
        perfil: "/ayuda/perfil"
    }

    const location = useLocation();
    const [currentContent, setCurrentContent] = useState(urlAyuda?.principal)

    useEffect(() => {
        /**
            si coincide la ruta del navegador con algún id 
            de los urlAyuda, entonces muestra el contenido correspondiente, 
            si no es así mostrará por defecto la pagina principal de ayuda
         */
        if (Object.values(urlAyuda).includes(location.pathname)) {
            setCurrentContent(location.pathname)
        } else {
            setCurrentContent(urlAyuda?.principal)
        }
    }, [location])

    return (
        <Content.Box currentURL={currentContent} className={'content-help'}>

            <Content.Help ayudaId={urlAyuda?.principal} >
                <MainHelp interfaceTexts={helpTexts?.main_help} />
            </Content.Help>
            <Content.Help ayudaId={urlAyuda?.libros}>
                <BooksHelp interfaceTexts={helpTexts} />
            </Content.Help>
            <Content.Help ayudaId={urlAyuda?.plataforma}>
                <PlatformHelp interfaceTexts={helpTexts} />
            </Content.Help>
            <Content.Help ayudaId={urlAyuda?.descarga}>
                <DownloadHelp interfaceTexts={helpTexts} />
            </Content.Help>
            <Content.Help ayudaId={urlAyuda?.apps}>
                <AppsHelp interfaceTexts={helpTexts} />
            </Content.Help>
            <Content.Help ayudaId={urlAyuda?.perfil}>
                <ProfileHelp interfaceTexts={helpTexts} />
            </Content.Help>

        </Content.Box>
    )
}